export default __webpack_public_path__ + "static/media/b2eBg.09ab81e8.png";